<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner
            :animation-duration="2000"
            :size="80"
            color="#63c2de"
            class="offset-6"
          >Entrar</semipolar-spinner>
        </div>
        <table-ads
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-credit-card mr-2'></i> Ads</h4>"
          v-else
        >
        </table-ads>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TableAds from "./TableAds.vue";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

export default {
  name: "tables",
  components: { TableAds, SemipolarSpinner },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre de conjunto", sortable: true },
        { key: "status", label: "Estado", sortable: true },
        {key:"acciones",label:"Acciones"}
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getAdsets();
  },
  methods: {
    getAdsets() {
      var adsets= store.getters.getAds;
      if (adsets.length == 0) {
        this.isLoading = true;
        store.dispatch("getAds").then(() => {
          var adsets = store.getters.getAds;
          shuffleArray([adsets]);
          this.isLoading = false;
          this.items = adsets;
          this.itemsArray = adsets;
        });
      } else {
        shuffleArray([adsets]);
        this.items = adsets;
        this.itemsArray = adsets;
      }
    }
  }
};
</script>
